import { Component, Input } from '@angular/core';

@Component({
    selector: 'pr-page',
    templateUrl: './pr-page.component.html',
    styleUrls: ['./pr-page.component.scss'],
    standalone: false
})
export class PrPageComponent {
  @Input() load: boolean = true;

  constructor() {}
}
